
import { GameState } from '../../GameContextTypes';

// Apply random market fluctuations to KPIs
export const applyRandomEvents = (kpis: GameState['kpis']) => {
  const updatedKpis = { ...kpis };
  const randomFactor = (Math.random() * 0.6) + 0.7; // 0.7 to 1.3 multiplier
  const randomEvent = Math.random();
  
  // 15% chance of a negative event
  if (randomEvent < 0.15) {
    const randomKpiIndex = Math.floor(Math.random() * 4);
    switch (randomKpiIndex) {
      case 0:
        updatedKpis.uptime = Math.max(90, updatedKpis.uptime - (randomFactor * 0.5));
        break;
      case 1:
        updatedKpis.energyCost = Math.min(0.12, updatedKpis.energyCost + (randomFactor * 0.002));
        break;
      case 2:
        updatedKpis.profitMargin = Math.max(10, updatedKpis.profitMargin - (randomFactor * 1));
        break;
      case 3:
        updatedKpis.efficiency = Math.max(60, updatedKpis.efficiency - (randomFactor * 0.8));
        break;
    }
  }
  // 10% chance of a positive event
  else if (randomEvent > 0.85) {
    const randomKpiIndex = Math.floor(Math.random() * 4);
    switch (randomKpiIndex) {
      case 0:
        updatedKpis.uptime = Math.min(100, updatedKpis.uptime + (randomFactor * 0.3));
        break;
      case 1:
        updatedKpis.energyCost = Math.max(0.03, updatedKpis.energyCost - (randomFactor * 0.001));
        break;
      case 2:
        updatedKpis.profitMargin = Math.min(40, updatedKpis.profitMargin + (randomFactor * 0.8));
        break;
      case 3:
        updatedKpis.efficiency = Math.min(95, updatedKpis.efficiency + (randomFactor * 0.5));
        break;
    }
  }
  
  return updatedKpis;
};
